module.exports = __webpack_public_path__ + "static/media/太原学院新校区综合供暖项目2.c4ebba5b.jpg";